import { Storage } from './util'

export function getToken() {
  return Storage.getSession('token')
}
export function getCompanyCode(key) {
  return Storage.getLoc(key + 'companycode')
}
export function getComypanyName(key) {
  return Storage.getLoc(key + 'comypanyname')
}
export function getRoleCode(key) {
  return Storage.getLoc(key + 'rolecode')
}
export function getRoleName(key) {
  return Storage.getLoc(key + 'rolename')
}
export function getAccount() {
  return Storage.getSession('account')
}
export function getCompanyId() {
  return Storage.getSession('companyId')
}
export function getRefreshToken() {
  return Storage.getLoc('refreshToken')
}
export function getUserInfo() {
  return Storage.getSession('userInfo')
}
export function setToken(token) {
  Storage.setSession({
    key: 'token',
    value: token
  })
}
export function setAccount(account) {
  Storage.setSession({
    key: 'account',
    value: account
  })
}
export function setRoleCode(key, code) {
  Storage.setLoc({
    key: key,
    value: code
  })
}
export function setRoleNname(key, code) {
  Storage.setLoc({
    key: key,
    value: code
  })
}
export function setComypanyName(key, code) {
  Storage.setLoc({
    key: key,
    value: code
  })
}
export function setComypanyCode(key, code) {
  Storage.setLoc({
    key: key,
    value: code
  })
}
export function setCompanyId(key, id) {
  Storage.setSession({
    key: key,
    value: id
  })
}
export function removeToken() {
  Storage.removeSession('token')
  Storage.removeSession('refreshToken')
}
export function setUserInfo(userInfo) {
  Storage.setSession({
    key: 'userInfo',
    value: userInfo
  })
}
export function permsJudge(value) {
  let Perms = []
  JSON.parse(sessionStorage.getItem('menu') || '[]').forEach((e) => {
    Perms.push(e.id)
    e.children.forEach((ce) => {
      Perms.push(ce.id)
    })
  })
  for (let item of Perms) {
    if (item === value) {
      return true
    }
  }
  return false
}
